const MAX_TABLE_HEAD_SEPARATOR_LENGTH = 1000;
const MAX_REPEAT_LENGTH = 50;

const UNESCAPED_REPEAT_PATTERN = /([_*~-])\1{49,}/g;
const ESCAPED_REPEAT_PATTERN = /(\\[_*~-])\1{49,}/g;

export function cleanMarkdown(markdown: string): string {
  const lines = markdown
    .trim()
    .split('\n')
    .map(line => {
      /**
       * An LLM bug caused this line to be really long (200K+ characters).
       * Fixes this from causing a rendering failure.
       */
      if (line.startsWith(`|---`)) {
        return line.slice(0, MAX_TABLE_HEAD_SEPARATOR_LENGTH);
      }
      return line;
    });

  return lines
    .join('\n')
    .replace(UNESCAPED_REPEAT_PATTERN, match => match[0].repeat(MAX_REPEAT_LENGTH))
    .replace(ESCAPED_REPEAT_PATTERN, match => match.slice(0, 2).repeat(MAX_REPEAT_LENGTH));
}
